import { generateSalePercentageBasedOnType } from 'utils';
import { SaleBadgeProps } from 'components/Badge/types';
import { StylesGhostPromotionSaleBadge } from './style';

export const GhostPromotionSaleBadge: React.FC<SaleBadgeProps> = ({
  salePercentage,
  salePercentageDisplayType,
}) => {
  return (
    <StylesGhostPromotionSaleBadge className="ghost-promotion-sale-badge">
      <div className="ghost-promotion-sale-badge--container">
        <img
          src="https://media.appcharge.com/defaults/ghost-sale-badge.png"
          alt="sale-badge"
          className="ghost-promotion-sale-badge--image"
        />
        <div className="ghost-promotion-sale-badge--number">
          {generateSalePercentageBasedOnType(
            salePercentage,
            salePercentageDisplayType,
          )}
          <div className="ghost-promotion-sale-badge--number-text">more</div>
        </div>
      </div>
    </StylesGhostPromotionSaleBadge>
  );
};
